import Api from "~/services/api"
export default (context, inject) => {
  const api = Api(context.$apiClient)
  inject("api", api)
};